export const getSectionDurations = (sections: any[]) => {
    const overtimeDuration = sections
        ?.filter((section) => section.type === "overtime")
        ?.reduce((total: number, section: any) => total + (section?.duration || 0), 0) ?? 0;

    const breakDuration = sections
        ?.filter((section) => section.type === "break")
        ?.reduce((total: number, section: any) => total + (section?.duration || 0), 0) ?? 0;

    return { overtimeDuration, breakDuration };
};
